module.exports = __webpack_public_path__ + "media/1A_DrillholeDesign.002bf414.mp4";